module.exports = __webpack_public_path__ + "img/ic_32_profile_persoenliche_angaben.ffd815af.svg";